export default __webpack_public_path__ + "static/media/logger.1a86b188.png";